import WordScrambler from '../../utils/wordScrambler';

const scramblerContainer = document.querySelector('.words-scrambler__container .words-scrambler__text');

const phrasesArray = Array.from(document.querySelectorAll('.words-scrambler__phrases__item')).map(
  (sentence) => sentence.innerHTML,
);

const scramblerInstance = new WordScrambler(scramblerContainer);

let counter = 0;

const initScrambler = (phrases, scramblerInst) => {
  scramblerInst.setText(phrases[counter]).then(() => {
    setTimeout(() => initScrambler(phrases, scramblerInst), 3000);
  });
  counter = (counter + 1) % phrases.length;
};

initScrambler(phrasesArray, scramblerInstance);
